module.exports = __webpack_public_path__ + "static/media/handbags_4_getty_tablet.9f631895.jpg";